import {useModal} from "../../../../hooks";
import {useUploadIncomingBarcode} from "../../../../pages/inventory/incoming/create/hooks/useUploadIncomingBarcode";
import {useState} from "react";

interface ScanBarcodeInnerPropsType {
    value: any[],
    setValue: (data: any) => any
}

// TODO: 바코드 스캔 임시 인터페이스
export default function ScanBarcodeInner({value, setValue}: ScanBarcodeInnerPropsType) {
    const {handleModal, resetModal} = useModal();

    const {mutateAsync: mutateAsyncUploadIncomingBarcode} = useUploadIncomingBarcode()

    const [tempBarcode, setTempBarcode] = useState<string>("")

    const onClose = () => {
        setTempBarcode("")
        resetModal(1)
    }

    const btnScanBarcode = () => {
        mutateAsyncUploadIncomingBarcode({barcode: tempBarcode}).then((res: any) => {
            if (res.data.code === "0000") {
                if (value.some(el => el.inventoryId === res.data.result.inventoryId)) {
                    handleModal({
                        isOpen: true,
                        contents: "중복된 품목은 추가할 수 없습니다.",
                        type: "alert",
                        depth: 2
                    });
                } else {
                    setValue([...value, {...res.data.result, changeAmount: 0}])
                    onClose()
                }
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                    depth: 2
                });
            }
        })
    }

    return <>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "30%"}}>
                    바코드
                </th>
                <td className="p-4px" onKeyDown={e => {
                    if (e.key === "Enter") {
                        btnScanBarcode()
                    }
                }}>
                    <input type="text" className="form-control"
                           value={tempBarcode}
                           onChange={e => setTempBarcode(e.target.value)}/>
                </td>
            </tr>
            </tbody>
        </table>
        <div className="mt-3 d-flex align-items-center justify-content-end">
            <button
                type="button"
                className="btn btn-outline-primary w-100px h-38px my-0"
                onClick={onClose}
            >
                취소
            </button>
            <button
                type="button"
                className="btn btn-dark w-100px h-38px my-0 ms-3"
                onClick={btnScanBarcode}
            >
                선택
            </button>
        </div>
    </>
}